import React from 'react';

interface KpiCardProps {
  label: string;
  value: string;
  hint?: string;
  accent?: string;
}

export function KpiCard({
  label, value, hint, accent,
}: KpiCardProps) {
  return (
    <div className="col-md-6 col-lg-4">
      <div className="card h-100">
        <div className="card-body">
          <div className="text-muted small text-uppercase mb-1">{label}</div>
          <div className={`fs-4 fw-bold ${accent ?? ''}`}>{value}</div>
          {hint && <div className="text-muted small mt-1">{hint}</div>}
        </div>
      </div>
    </div>
  );
}
